import { Component } from '@theme/component';

/**
 * A custom element that renders a video background.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} videoSources - The video sources.
 * @property {HTMLVideoElement} videoElement - The video element.
 * @property {HTMLButtonElement} playElement - The video element.
 * @property {HTMLButtonElement} muteElement - The video element.
 * @property {HTMLElement} videoControls - The video element.
 *
 * @extends Component<Refs>
 */
export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement', 'playElement', 'muteElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement, playElement, muteElement, videoControls } = this.refs;

    for (const source of videoSources) {
      const { videoSource } = source.dataset;

      if (videoSource) source.setAttribute('src', videoSource);
    }

    videoElement.load();
    if(!this.getAttribute('data-autoplay')) {
      videoElement.pause();
      videoControls.classList.remove('is-playing');
    }

    playElement.addEventListener('click', (e) => {
      e.preventDefault();
      if (videoElement.paused) videoElement.play();
      else videoElement.pause();
      videoControls.classList.toggle('is-playing');
    });

    muteElement.addEventListener('click', (e) => {
      e.preventDefault();
      videoElement.muted = !videoElement.muted;
      videoControls.classList.toggle('is-mute');
    });
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}
